var computeRowWidth = function (_a) {
    var visibleColumns = _a.visibleColumns, columnsWidth = _a.columnsWidth, hasVerticalScroll = _a.hasVerticalScroll, layoutWidth = _a.layoutWidth, scrollbarWidth = _a.scrollbarWidth;
    var width = visibleColumns.reduce(function (count, column) { return count + columnsWidth[column.key]; }, 0);
    // When monitor scale on Windows equal 125/175 then horizontal scroll is render, but row width correct.
    // Detect window scale and force correct row size
    var delta = window.devicePixelRatio % 0.5 && navigator.platform.includes('Win') ? 1 : 0;
    if (width < layoutWidth - scrollbarWidth) {
        if (hasVerticalScroll) {
            return layoutWidth - scrollbarWidth - delta;
        }
        return layoutWidth - delta;
    }
    return width - delta;
};
export default computeRowWidth;
//# sourceMappingURL=computeRowWidth.js.map